module.exports = __webpack_public_path__ + "img/bg2.72c77654.jpg";